const theme = {
  colors: {
    //Main theme
    colorOnyx: "#393e41",
    colorTimberWolf: "#d3d0cb",
    colorMaize: "#e2c044",
    colorTeal: "#587B7F",
    colorLavender: "#C2C2FF",
    //experiment colors
    colorFogra: "#040404",
    colorCultured: "#f0f6f6",
    colorBlack: "#0f0f0f",
  },

  fonts: {
    fontFamilyOne: "'Playfair Display', serif",
    fontFamilyTwo: "'Nunito Sans', sans-serif",
    fontFamilyForm: "'Arimo','Crimson Pro',sans-serif",
    fontFamilyFormInputs: '"poppins", "sans-serif"',
  },
  deviceWidths: {
    desktopWidth: "1440px",
    laptopWidth: "1024px",
    tabletWidth: "768px",
    mobileWidth: "480px",
  },
};

export default theme;
